import React from 'react';
import styled from 'styled-components/macro';
import { Button } from '@material-ui/core';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';

export const ChatterButton = (props) => {
  const { openChatter, setOpenChatter } = props;

  const handleOnClick = () => {
    setOpenChatter(!openChatter);
  };

  return (
    <Wrapper>
      <Button
        className='ack-btn'
        variant='contained'
        onClick={() => handleOnClick()}
      >
        <ChatOutlinedIcon />
      </Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: auto;
  display: flex;
  align-items: center;
  position: fixed;
  right: 10px;
  bottom: 0;

  .ack-btn {
    color: ${p => p.theme.buttonFont};
    background: ${p => p.theme.buttonColor};
    width: 50px;
    font-size: 12px;
    padding: 5px;
    height: 30px;
    line-height: 1;
  }
`;
